<template>
    <div class="container">
      <h1>Converter para Minúsculas</h1>
      <div class="converter-box">
        <textarea v-model="inputText" placeholder="Cole seu texto aqui"></textarea>
        <button @click="convertText">Converter</button>
        <textarea ref="outputBox" v-model="outputText" readonly @click="copyToClipboard"></textarea>
        <p v-if="copied" class="copied-message">Texto copiado para a área de transferência! ✅</p>
      </div>
    </div>
  </template>
  
  <script>
  export default {
    name: "LowercaseConverter",
    data() {
      return {
        inputText: "",
        outputText: "",
        copied: false
      };
    },
    methods: {
      convertText() {
        this.outputText = this.inputText.toLowerCase();
        this.copyToClipboard();
      },
      copyToClipboard() {
        if (this.$refs.outputBox) {
          this.$refs.outputBox.select();
          document.execCommand("copy");
          this.copied = true;
          setTimeout(() => (this.copied = false), 2000);
        }
      }
    }
  };
  </script>
  